<template>
  <div class="ui-container">
    <h2>Typography</h2>
    <h3>Elements</h3>
    <div class="ui-block">
      <div class="block-child">
        <small class="code-block" v-text="'h1'" />
        <h1>Title 1</h1>
      </div>
      <div class="block-child">
        <small class="code-block" v-text="'h2'" />
        <h2>Title 2</h2>
      </div>
      <div class="block-child">
        <small class="code-block" v-text="'h3'" />
        <h3>Title 3</h3>
      </div>
      <div class="block-child">
        <small class="code-block" v-text="'h4'" />
        <h4>Title 4</h4>
      </div>
      <div class="block-child">
        <small class="code-block" v-text="'a'" />
        <a href="#">Link</a>
      </div>
      <div class="block-child">
        <small class="code-block" v-text="'p'" />
        <p>Paragraph</p>
      </div>
      <div class="block-child">
        <small class="code-block" v-text="'small'" />
        <small>Small text</small>
      </div>
      <div class="block-child">
        <small class="code-block" v-text="'.tiny'" />
        <div class="tiny">Tiny text</div>
      </div>
    </div>
    <h3>Style</h3>
    <div class="ui-block">
      <div class="block-child">
        <small class="code-block" v-text="'.extralight'" />
        <p class="extralight">Lorem ipsum</p>
      </div>
      <div class="block-child">
        <small class="code-block" v-text="'.extralight-italic'" />
        <p class="extralight-italic">Lorem ipsum</p>
      </div>
      <div class="block-child">
        <small class="code-block" v-text="'.light'" />
        <p class="light">Lorem ipsum</p>
      </div>
      <div class="block-child">
        <small class="code-block" v-text="'.light-italic'" />
        <p class="light-italic">Lorem ipsum</p>
      </div>
      <div class="block-child">
        <small class="code-block" v-text="'Default'" />
        <p>Lorem ipsum</p>
      </div>
      <div class="block-child">
        <small class="code-block" v-text="'.italic'" />
        <p class="italic">Lorem ipsum</p>
      </div>
      <div class="block-child">
        <small class="code-block" v-text="'.semibold'" />
        <p class="semibold">Lorem ipsum</p>
      </div>
      <div class="block-child">
        <small class="code-block" v-text="'.semibold-italic'" />
        <p class="semibold-italic">Lorem ipsum</p>
      </div>
      <div class="block-child">
        <small class="code-block" v-text="'.bold'" />
        <p class="bold">Lorem ipsum</p>
      </div>
      <div class="block-child">
        <small class="code-block" v-text="'.bold-italic'" />
        <p class="bold-italic">Lorem ipsum</p>
      </div>
      <div class="block-child">
        <small class="code-block" v-text="'.extrabold'" />
        <p class="extrabold">Lorem ipsum</p>
      </div>
      <div class="block-child">
        <small class="code-block" v-text="'.extrabold-italic'" />
        <p class="extrabold-italic">Lorem ipsum</p>
      </div>
    </div>
  </div>
</template>
